import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class MicrofrontendsService {
  microfrontends: any = {};

  constructor() {}

  bootstrap(): void {
    if (environment.microfrontends) {
      // eslint-disable-next-line
      document.addEventListener(environment.sids.services, (event: any) =>
        this.onMicrofrontendEvent(event.detail)
      );
      Object.keys(environment.microfrontends).forEach((micro) =>
        this.loadMicrofrontend(micro, environment.microfrontends[micro])
      );
    }
  }

  loadMicrofrontend(microfrontendName: string, microfrontendConfig: any): void {
    this.microfrontends[microfrontendName] = false;

    if (this.isAllowed(microfrontendConfig)) {
      // eslint-disable-next-line
      const scriptElement = document.createElement('script');
      scriptElement.id = microfrontendName;
      scriptElement.setAttribute('data-microfrontend', microfrontendName);
      scriptElement.setAttribute('src', microfrontendConfig.script);
      scriptElement.onload = () => {
        this.bootstrapMicrofrontend(microfrontendName, microfrontendConfig);
      };
      // eslint-disable-next-line
      document.body.appendChild(scriptElement);
    }
  }

  bootstrapMicrofrontend(microfrontendName: string, microfrontendConfig: any): void {
    this.fireMicrofrontendEvent(microfrontendName, 'bootstrap', {
      // locale: i18n.global.locale,
      serviceId: environment.sids.services,
      ...microfrontendConfig
    });
  }

  // refreshAuthorization() {
  //   if (config.microfrontends) {
  //     Object.keys(config.microfrontends).forEach((microfrontendName) => {
  //       const microfrontendConfig = config.microfrontends[microfrontendName];
  //       if (microfrontendConfig.authorization && _isAllowed(microfrontendConfig)) {
  //         this.bootstrapMicrofrontend(microfrontendName, microfrontendConfig);
  //       }
  //     });
  //   }
  // },

  isReady(microfrontendName: string): boolean {
    return !!this.microfrontends[microfrontendName];
  }

  fireMicrofrontendEvent(microfrontendName: string, action: string, payload: any): void {
    if (microfrontendName) {
      // eslint-disable-next-line
      document.dispatchEvent(
        new CustomEvent(microfrontendName, { detail: { action: action, payload: payload } })
      );
    }
  }

  onMicrofrontendEvent(detail: any): void {
    const { microfrontendName, action } = detail;
    switch (action) {
      case 'ready':
        this.microfrontends[microfrontendName] = true;
        break;
    }
  }

  private isAllowed(microfrontendConfig) {
    if (!microfrontendConfig || !microfrontendConfig.script || !microfrontendConfig.active)
      return false;
    return true;
  }
}
